import { Pipe, PipeTransform } from '@angular/core';

// Reemplaza el texto "hace X min/h" quemado a mano en dashboard.html / _nav.js (notif panel) —
// calcula el mismo formato desde un timestamp ISO real en vez de escribirlo literal.
@Pipe({
  name: 'relativeTime',
  standalone: true,
  pure: true,
})
export class RelativeTimePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';

    const diffMinutes = Math.round((Date.now() - new Date(value).getTime()) / (60 * 1000));
    if (diffMinutes < 1) return 'Justo ahora';
    if (diffMinutes < 60) return `Hace ${diffMinutes} min`;

    const diffHours = Math.round(diffMinutes / 60);
    if (diffHours < 24) return `Hace ${diffHours} ${diffHours === 1 ? 'hora' : 'horas'}`;

    const diffDays = Math.round(diffHours / 24);
    return `Hace ${diffDays} ${diffDays === 1 ? 'día' : 'días'}`;
  }
}
